// src/components/Sidebar.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import {
  DashboardOutlined, ControlOutlined, ShopOutlined,
  BarChartOutlined, DatabaseOutlined, SettingOutlined,
  MobileOutlined, ToolOutlined, AlertOutlined, CloudOutlined,
  CloseOutlined
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ visible, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { key: '/app/admin', icon: <DashboardOutlined />, label: t('nav.dashboard') },
    { key: '/app/collection', icon: <ControlOutlined />, label: t('nav.collection') },
    { key: '/app/supply', icon: <ShopOutlined />, label: t('nav.supplyDemand') },
    { key: '/app/cloud', icon: <CloudOutlined />, label: t('nav.cloud') },
    { key: '/app/logs', icon: <BarChartOutlined />, label: t('nav.log') },
    { key: '/app/data', icon: <DatabaseOutlined />, label: t('nav.data') },
    { key: '/app/config', icon: <SettingOutlined />, label: t('nav.config') },
    { key: '/app/assets', icon: <MobileOutlined />, label: t('nav.assets') },
    { key: '/app/operations', icon: <ToolOutlined />, label: t('nav.operations') },
    { key: '/app/alerts', icon: <AlertOutlined />, label: t('nav.alerts') },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
    if (window.innerWidth <= 768) {
      onClose();
    }
  };

  return (
    <div className={`sidebar-container ${visible ? 'sidebar-visible' : ''}`}>
      <div className="sidebar-logo-area">
        <img src="/logo.png" alt="VPP EMS" 
            style={{
            // height: 56,
            // width: 'auto',
            // marginBottom: 8,
            background: 'rgba(243, 246, 248, 0.5)',
            // borderRadius: 10,
            // padding: '8px 16px',
            border: '1px solid rgba(98, 123, 185, 0.3)',
          }}
        className="sidebar-logo-img" />
        {visible && (
          <button className="sidebar-close-btn" onClick={onClose}>
            <CloseOutlined />
          </button>
        )}
      </div>
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
        onClick={handleMenuClick}
      />
      {/* <div className="sidebar-bottom">VPP EMS V1.0</div> */}
    </div>
  );
};

export default Sidebar;
